// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Meow+Script&family=Roboto:wght@400;500;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  /* Typography */
  --font-family-interface: Roboto, -apple-system, BlinkMacSystemFont, "Segoe UI",
    "Helvetica Neue", Arial, sans-serif;
  --font-family-brand: "Meow Script", cursive;
  --font-size-xs: 1.2rem;
  --font-size-sm: 1.4rem;
  --font-size-md: 1.6rem;
  --font-size-lg: 1.8rem;
  --font-size-xl: 2rem;
  --font-size-title-sm: clamp(2rem, 1.8rem + 0.6vw, 2.6rem);
  --font-size-title-md: clamp(2.4rem, 2rem + 1vw, 3.4rem);
  --font-size-title-lg: clamp(3rem, 2.4rem + 2vw, 4.8rem);
  --icon-size-sm: 1.6rem;
  --icon-size-md: 2rem;
  --icon-size-lg: clamp(2.4rem, 2.2rem + 0.6vw, 3rem);
  --line-height-body: 1.5;
  --line-height-heading: 1.2;

  /* Spacing and interactive dimensions */
  --space-1: 0.4rem;
  --space-2: 0.8rem;
  --space-3: 1.2rem;
  --space-4: 1.6rem;
  --space-5: 2rem;
  --space-6: 2.4rem;
  --space-8: 3.2rem;
  --space-10: 4rem;
  --touch-target-size: 4.4rem;
  --mobile-navigation-height: 5.6rem;
  --app-header-height: 5.6rem;
  --sidebar-width: clamp(18rem, 24vw, 24rem);
  --sidebar-width-compact: 6rem;
  --sidebar-drawer-width: min(88vw, 32rem);

  /* Shape, surfaces and elevation */
  --border-width: 0.1rem;
  --border-radius-sm: 0.6rem;
  --border-radius-md: 1.2rem;
  --radius-sm: var(--border-radius-sm);
  --radius-md: var(--border-radius-md);
  --radius-lg: 2rem;
  --radius-pill: 999rem;
  --border-radius-pill: var(--radius-pill);
  --surface-primary: #ffffff;
  --surface-secondary: #fff5f8;
  --surface-overlay: rgb(0 0 0 / 56%);
  --border-color: #eadde2;
  --shadow-sm: 0 0.1rem 0.4rem rgb(38 20 28 / 7%);
  --shadow-md: 0 0.8rem 2.4rem rgb(38 20 28 / 13%);

  /* Text, actions and states */
  --text-primary: #262626;
  --text-secondary: #62626a;
  --text-on-accent: #ffffff;
  /* Paleta oficial extraída de public/cores.jpeg. */
  --color-primary: #e91e63;
  --color-primary-dark: #c2185b;
  --color-secondary: #ec407a;
  --color-accent: #f06292;
  --color-background: #fffafb;
  --color-surface: #ffffff;
  --color-surface-soft: #fff1f5;
  --color-text: #2d2025;
  --color-text-muted: #725f67;
  --color-border: #eadde2;
  --color-primary-hover: #c2185b;
  --color-danger: #b42318;
  --action-primary: var(--color-primary);
  --action-primary-hover: var(--color-primary-dark);
  --action-active: var(--color-primary);
  --focus-color: #a50f49;
  --focus-ring: 0 0 0 0.3rem var(--focus-color);
  --heart-icon-default: #6b6b73;
  --heart-icon: #d92d45;
  --delete: #b42318;
  --delete-hover: #912018;
  --motion-duration-fast: 180ms;
  --motion-duration-normal: 220ms;
  --motion-easing-standard: ease;

  /* Layer hierarchy */
  --layer-content: 0;
  --layer-content-overlay: 80;
  --layer-bottom-nav: 100;
  --layer-header: 110;
  --layer-drawer: 200;
  --layer-action-sheet: 300;
  --layer-toast: 400;

  /* Device safe areas */
  --safe-area-top: env(safe-area-inset-top, 0px);
  --safe-area-right: env(safe-area-inset-right, 0px);
  --safe-area-bottom: env(safe-area-inset-bottom, 0px);
  --safe-area-left: env(safe-area-inset-left, 0px);

  /* Temporary aliases for existing component styles. */
  --primary-backgroud: var(--surface-primary);
  --secondary-background: var(--surface-secondary);
  --secondary_background: var(--surface-secondary);
  --button-link-color: var(--action-primary);
  --button-link--hover-color: var(--action-primary-hover);
  --text-primamry: var(--text-primary);
}

html {
  font-size: 62.5%;
  overflow-x: hidden;
  overflow-y: auto;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

* {
  margin: 0;
  padding: 0;
}

body {
  min-width: 32rem;
  background-color: var(--color-background);
  color: var(--text-primary);
  font-family: var(--font-family-interface);
  font-size: var(--font-size-md);
  line-height: var(--line-height-body);
  overflow-x: hidden;
  overflow-y: auto;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
}

input {
  border: var(--border-width) solid var(--border-color);
  border-radius: var(--border-radius-md);
  background: var(--surface-primary);
  color: var(--text-primary);
  font: inherit;
}

button {
  border: 0;
  border-radius: var(--border-radius-md);
  background: var(--action-primary);
  box-shadow: none;
  color: var(--text-on-accent);
  font: inherit;
  font-weight: 600;
}

button:hover {
  background: var(--action-primary-hover);
}

a {
  color: var(--text-primary);
  text-decoration: none;
}

a:hover {
  color: var(--action-primary-hover);
}

:where(a, button, input, textarea, select, [tabindex]):focus-visible {
  outline: 0.2rem solid var(--focus-color);
  outline-offset: 0.2rem;
}

@media (prefers-reduced-motion: reduce) {
  *,
  *::before,
  *::after {
    scroll-behavior: auto !important;
    transition-duration: 0.01ms !important;
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAEA;EACE,eAAe;EACf;uCACqC;EACrC,2CAA2C;EAC3C,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,oBAAoB;EACpB,yDAAyD;EACzD,uDAAuD;EACvD,uDAAuD;EACvD,sBAAsB;EACtB,oBAAoB;EACpB,mDAAmD;EACnD,uBAAuB;EACvB,0BAA0B;;EAE1B,uCAAuC;EACvC,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,2BAA2B;EAC3B,kCAAkC;EAClC,2BAA2B;EAC3B,0CAA0C;EAC1C,6BAA6B;EAC7B,wCAAwC;;EAExC,kCAAkC;EAClC,sBAAsB;EACtB,0BAA0B;EAC1B,0BAA0B;EAC1B,oCAAoC;EACpC,oCAAoC;EACpC,iBAAiB;EACjB,qBAAqB;EACrB,wCAAwC;EACxC,0BAA0B;EAC1B,4BAA4B;EAC5B,mCAAmC;EACnC,uBAAuB;EACvB,+CAA+C;EAC/C,gDAAgD;;EAEhD,6BAA6B;EAC7B,uBAAuB;EACvB,yBAAyB;EACzB,yBAAyB;EACzB,kDAAkD;EAClD,wBAAwB;EACxB,6BAA6B;EAC7B,0BAA0B;EAC1B,uBAAuB;EACvB,2BAA2B;EAC3B,wBAAwB;EACxB,6BAA6B;EAC7B,qBAAqB;EACrB,2BAA2B;EAC3B,uBAAuB;EACvB,8BAA8B;EAC9B,uBAAuB;EACvB,sCAAsC;EACtC,iDAAiD;EACjD,qCAAqC;EACrC,sBAAsB;EACtB,6CAA6C;EAC7C,6BAA6B;EAC7B,qBAAqB;EACrB,iBAAiB;EACjB,uBAAuB;EACvB,6BAA6B;EAC7B,+BAA+B;EAC/B,8BAA8B;;EAE9B,oBAAoB;EACpB,kBAAkB;EAClB,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;;EAElB,sBAAsB;EACtB,8CAA8C;EAC9C,kDAAkD;EAClD,oDAAoD;EACpD,gDAAgD;;EAEhD,qDAAqD;EACrD,2CAA2C;EAC3C,gDAAgD;EAChD,gDAAgD;EAChD,0CAA0C;EAC1C,uDAAuD;EACvD,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;;EAGE,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,yCAAyC;EACzC,0BAA0B;EAC1B,yCAAyC;EACzC,8BAA8B;EAC9B,oCAAoC;EACpC,kBAAkB;EAClB,gBAAgB;EAChB,kCAAkC;EAClC,mCAAmC;AACrC;;AAEA;EACE,qDAAqD;EACrD,sCAAsC;EACtC,kCAAkC;EAClC,0BAA0B;EAC1B,aAAa;AACf;;AAEA;EACE,SAAS;EACT,sCAAsC;EACtC,iCAAiC;EACjC,gBAAgB;EAChB,4BAA4B;EAC5B,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,0BAA0B;EAC1B,qBAAqB;AACvB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,wCAAwC;EACxC,sBAAsB;AACxB;;AAEA;EACE;;;IAGE,gCAAgC;IAChC,sCAAsC;IACtC,qCAAqC;IACrC,uCAAuC;EACzC;AACF","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Meow+Script&family=Roboto:wght@400;500;600;700&display=swap\");\r\n\r\n:root {\r\n  /* Typography */\r\n  --font-family-interface: Roboto, -apple-system, BlinkMacSystemFont, \"Segoe UI\",\r\n    \"Helvetica Neue\", Arial, sans-serif;\r\n  --font-family-brand: \"Meow Script\", cursive;\r\n  --font-size-xs: 1.2rem;\r\n  --font-size-sm: 1.4rem;\r\n  --font-size-md: 1.6rem;\r\n  --font-size-lg: 1.8rem;\r\n  --font-size-xl: 2rem;\r\n  --font-size-title-sm: clamp(2rem, 1.8rem + 0.6vw, 2.6rem);\r\n  --font-size-title-md: clamp(2.4rem, 2rem + 1vw, 3.4rem);\r\n  --font-size-title-lg: clamp(3rem, 2.4rem + 2vw, 4.8rem);\r\n  --icon-size-sm: 1.6rem;\r\n  --icon-size-md: 2rem;\r\n  --icon-size-lg: clamp(2.4rem, 2.2rem + 0.6vw, 3rem);\r\n  --line-height-body: 1.5;\r\n  --line-height-heading: 1.2;\r\n\r\n  /* Spacing and interactive dimensions */\r\n  --space-1: 0.4rem;\r\n  --space-2: 0.8rem;\r\n  --space-3: 1.2rem;\r\n  --space-4: 1.6rem;\r\n  --space-5: 2rem;\r\n  --space-6: 2.4rem;\r\n  --space-8: 3.2rem;\r\n  --space-10: 4rem;\r\n  --touch-target-size: 4.4rem;\r\n  --mobile-navigation-height: 5.6rem;\r\n  --app-header-height: 5.6rem;\r\n  --sidebar-width: clamp(18rem, 24vw, 24rem);\r\n  --sidebar-width-compact: 6rem;\r\n  --sidebar-drawer-width: min(88vw, 32rem);\r\n\r\n  /* Shape, surfaces and elevation */\r\n  --border-width: 0.1rem;\r\n  --border-radius-sm: 0.6rem;\r\n  --border-radius-md: 1.2rem;\r\n  --radius-sm: var(--border-radius-sm);\r\n  --radius-md: var(--border-radius-md);\r\n  --radius-lg: 2rem;\r\n  --radius-pill: 999rem;\r\n  --border-radius-pill: var(--radius-pill);\r\n  --surface-primary: #ffffff;\r\n  --surface-secondary: #fff5f8;\r\n  --surface-overlay: rgb(0 0 0 / 56%);\r\n  --border-color: #eadde2;\r\n  --shadow-sm: 0 0.1rem 0.4rem rgb(38 20 28 / 7%);\r\n  --shadow-md: 0 0.8rem 2.4rem rgb(38 20 28 / 13%);\r\n\r\n  /* Text, actions and states */\r\n  --text-primary: #262626;\r\n  --text-secondary: #62626a;\r\n  --text-on-accent: #ffffff;\r\n  /* Paleta oficial extraída de public/cores.jpeg. */\r\n  --color-primary: #e91e63;\r\n  --color-primary-dark: #c2185b;\r\n  --color-secondary: #ec407a;\r\n  --color-accent: #f06292;\r\n  --color-background: #fffafb;\r\n  --color-surface: #ffffff;\r\n  --color-surface-soft: #fff1f5;\r\n  --color-text: #2d2025;\r\n  --color-text-muted: #725f67;\r\n  --color-border: #eadde2;\r\n  --color-primary-hover: #c2185b;\r\n  --color-danger: #b42318;\r\n  --action-primary: var(--color-primary);\r\n  --action-primary-hover: var(--color-primary-dark);\r\n  --action-active: var(--color-primary);\r\n  --focus-color: #a50f49;\r\n  --focus-ring: 0 0 0 0.3rem var(--focus-color);\r\n  --heart-icon-default: #6b6b73;\r\n  --heart-icon: #d92d45;\r\n  --delete: #b42318;\r\n  --delete-hover: #912018;\r\n  --motion-duration-fast: 180ms;\r\n  --motion-duration-normal: 220ms;\r\n  --motion-easing-standard: ease;\r\n\r\n  /* Layer hierarchy */\r\n  --layer-content: 0;\r\n  --layer-content-overlay: 80;\r\n  --layer-bottom-nav: 100;\r\n  --layer-header: 110;\r\n  --layer-drawer: 200;\r\n  --layer-action-sheet: 300;\r\n  --layer-toast: 400;\r\n\r\n  /* Device safe areas */\r\n  --safe-area-top: env(safe-area-inset-top, 0px);\r\n  --safe-area-right: env(safe-area-inset-right, 0px);\r\n  --safe-area-bottom: env(safe-area-inset-bottom, 0px);\r\n  --safe-area-left: env(safe-area-inset-left, 0px);\r\n\r\n  /* Temporary aliases for existing component styles. */\r\n  --primary-backgroud: var(--surface-primary);\r\n  --secondary-background: var(--surface-secondary);\r\n  --secondary_background: var(--surface-secondary);\r\n  --button-link-color: var(--action-primary);\r\n  --button-link--hover-color: var(--action-primary-hover);\r\n  --text-primamry: var(--text-primary);\r\n}\r\n\r\nhtml {\r\n  font-size: 62.5%;\r\n  overflow-x: hidden;\r\n  overflow-y: auto;\r\n}\r\n\r\n*,\r\n*::before,\r\n*::after {\r\n  box-sizing: border-box;\r\n}\r\n\r\n* {\r\n  margin: 0;\r\n  padding: 0;\r\n}\r\n\r\nbody {\r\n  min-width: 32rem;\r\n  background-color: var(--color-background);\r\n  color: var(--text-primary);\r\n  font-family: var(--font-family-interface);\r\n  font-size: var(--font-size-md);\r\n  line-height: var(--line-height-body);\r\n  overflow-x: hidden;\r\n  overflow-y: auto;\r\n  -moz-osx-font-smoothing: grayscale;\r\n  -webkit-font-smoothing: antialiased;\r\n}\r\n\r\ninput {\r\n  border: var(--border-width) solid var(--border-color);\r\n  border-radius: var(--border-radius-md);\r\n  background: var(--surface-primary);\r\n  color: var(--text-primary);\r\n  font: inherit;\r\n}\r\n\r\nbutton {\r\n  border: 0;\r\n  border-radius: var(--border-radius-md);\r\n  background: var(--action-primary);\r\n  box-shadow: none;\r\n  color: var(--text-on-accent);\r\n  font: inherit;\r\n  font-weight: 600;\r\n}\r\n\r\nbutton:hover {\r\n  background: var(--action-primary-hover);\r\n}\r\n\r\na {\r\n  color: var(--text-primary);\r\n  text-decoration: none;\r\n}\r\n\r\na:hover {\r\n  color: var(--action-primary-hover);\r\n}\r\n\r\n:where(a, button, input, textarea, select, [tabindex]):focus-visible {\r\n  outline: 0.2rem solid var(--focus-color);\r\n  outline-offset: 0.2rem;\r\n}\r\n\r\n@media (prefers-reduced-motion: reduce) {\r\n  *,\r\n  *::before,\r\n  *::after {\r\n    scroll-behavior: auto !important;\r\n    transition-duration: 0.01ms !important;\r\n    animation-duration: 0.01ms !important;\r\n    animation-iteration-count: 1 !important;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
